import React from 'react';
import { Button, Icon, Label } from 'semantic-ui-react';
import { useIntl } from 'react-intl';
import { validationClasses } from '@/utils/errors';
import { camelConverter } from '../../helper';

const FormAuthButton = ({
  auth,
  authenticated,
  authenticating,
  authenticationError,
  disabled,
  field,
  validationError,
}) => {
  const intl = useIntl();
  return (
    <Button as="div" labelPosition="right" className="aridhia-form-auth-button">
      <Button
        id={camelConverter(field.name, '_')}
        content={field.placeholder}
        disabled={disabled}
        className={validationClasses(validationError)}
        onClick={disabled ? null : () => auth()}
        loading={authenticating}
      />
      {field.label && (<Label basic pointing="left" content={field.label} />)}
      {authenticated && (
        <Icon
          size="large"
          name="check circle outline"
          color="green"
          className="ml-10 mt-5"
          alt={intl.formatMessage({ id: 'success.title' })}
        />
      )}
      {authenticationError && (
        <Icon
          size="large"
          name="times circle outline"
          color="red"
          className="ml-10 mt-5"
          alt={intl.formatMessage({ id: 'error.title' })}
        />
      )}
    </Button>
  );
};

export default FormAuthButton;
